// extracted by mini-css-extract-plugin
export default {"searchTextContainer":"styles_searchTextContainer__lZ3G1","text":"styles_text__w3wuy"};